
<template>
  <v-container>
    <v-row class="align-center justify-center">
      <v-col cols="2" class="pa-1">
        <span> Tiêu đề tiếng anh</span>
      </v-col>
      <v-col cols="10" class="pa-1">
        <hnr-input :text="title" @input="update" v-model="detailAsk.title_en"></hnr-input>
      </v-col>
    </v-row>
    <v-row class="align-center justify-center">
      <v-col cols="2" class="pa-1">
        <span> Tiêu đề SEO tiếng anh</span>
      </v-col>
      <v-col cols="10" class="pa-1">
        <hnr-input :text="detailAsk.seo_title_en" @input="update" v-model="detailAsk.seo_title_en"></hnr-input>
      </v-col>
    </v-row>

    <v-row class="align-center justify-center">
      <v-col cols="2" class="pa-1">
        <span> Mô tả SEO tiếng anh</span>
      </v-col>
      <v-col cols="10" class="pa-1">
        <hnr-area-input :text="detailAsk.seo_description_en" @input="update" v-model="detailAsk.seo_description_en"></hnr-area-input>
      </v-col>
    </v-row>

    <v-row class="align-center justify-center">
      <v-col cols="2" class="pa-1">
        <span> Từ khóa SEO tiếng anh</span>
      </v-col>
      <v-col cols="10" class="pa-1">
        <hnr-area-input :text="detailAsk.seo_key_en" @input="update" v-model="detailAsk.seo_key_en"></hnr-area-input>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import HnrInput from '@/components/elements/hnr-input'
import HnrAreaInput from '@/components/elements/hnr-area-input'
export default {
  props: {
    ask: Object,
  },
  watch: {
    ask: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.detailAsk = newVal;
      }
    }
  },
  data() {
    return {
      detailAsk: {},
      title:""
    };
  },
  mounted() {
   this.title = this.detailAsk.title_en.replace(/(<([^>]+)>)/g, "");
    },
  components: {
    HnrInput,
    HnrAreaInput
  },
  methods: {
    onClick() {
    },
    update() {
      this.$emit("input");
    },
  },
};
</script>

<style lang="scss">
</style>
